import { useParams } from "react-router-dom";
import { createContext, useContext, useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { primeClient2 } from "../../../../axios/primeClient";
import { Card } from "../../../../Components/Card";
import Recommendations from "../../../../Components/Recommendations";
import { useTranslation } from "react-i18next";
import { Colors } from "../../../../constants/Colors";

const DataContext = createContext();

export const CapacityForecast = () => {
  const { forecastId, resource } = useParams();
  const [urlImage, setUrlImage] = useState("https://via.placeholder.com/400");

  const { data, isLoading, error } = useFetch({
    url: `/device_condition/detail/${resource.toLowerCase()}?network%20id=${forecastId}`,
    client: primeClient2,
  });

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (data) {
      setUrlImage(data.url);
    }
  }, [data]);

  return (
    <DataContext.Provider value={{ data, isLoading, error, t, i18n }}>
      <div
        style={{
          padding: "1rem",
          width: "100%",
          height: "100%",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            fontSize: "1.25rem",
            marginBottom: "0.5rem",
            fontWeight: "bold",
          }}
        >
          {t("prime.detailAnalysis.header")}
        </div>
        <DeviceDescriptionCard resource={resource} />

        {/* render image */}
        <Card
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
            marginTop: "1rem",
            backgroundColor: "white",
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            padding: "1rem",
          }}
        >
          <img
            src={urlImage}
            alt="Capacity Forecast"
            style={{ width: "100%", maxWidth: "40rem", maxHeight: "20rem" }}
          />


          <TrendTableCard />
          < br /> <hr /> < br />

          <SummaryAnalysisCard />
          < br /> <hr /> < br />
          <Recommendations rootCause={isLoading || error ? [] : [{ cpu: [data.cpu_index] }]} deviceName={isLoading || error ? "Device Name" : data.node_inventory_name} />
        </Card>

      </div>
    </DataContext.Provider>
  );
};

const DeviceDescriptionCard = ({ resource }) => {
  const { data, isLoading, error } = useContext(DataContext);

  return (
    <Card
      style={{
        width: "100%",
        maxWidth: "400px",
        backgroundColor: Colors.primary100,
        color: Colors.white,
        padding: "0.5rem 1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <div>
          {isLoading || error ? "Device Name" : data.node_inventory_name}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          {resource} |{" "}
          {isLoading || error ? "Node Inventory Name" : data.cpu_index}
        </div>
      </div>
    </Card>
  );
};

const TrendTableCard = () => {
  const { data, isLoading, error } = useContext(DataContext);

  return (
    <div
      style={{

      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
                borderBottomLeftRadius: "5px",
                borderTopLeftRadius: "5px",
              }}
            >
              Trend Slope
            </th>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
              }}
            >
              Critical
            </th>
            <th
              style={{
                backgroundColor: Colors.neutral10,
                padding: "0.5rem 1rem",
                marginBottom: "5px",
                fontSize: "0.8rem",
                fontWeight: 700,
                borderBottomRightRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              At Capacity
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr style={{ fontSize: "0.8rem" }}>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : error ? (
            <tr style={{ fontSize: "0.8rem" }}>
              <td colSpan="4">Error: {error.message}</td>
            </tr>
          ) : (
            <tr style={{ fontSize: "0.8rem" }}>
              <td style={{ textAlign: "center" }}>{data.trend_percentage}</td>
              <td style={{ textAlign: "center" }}>
                {data.exceed_threshold_time.slice(0, 16)}
              </td>
              <td style={{ textAlign: "center" }}>
                {data.peak_time.slice(0, 16)}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const SummaryAnalysisCard = () => {
  const { data, isLoading, error } = useContext(DataContext);
  return (
    <div
      style={{
      }}
    >
      <div
        style={{
          fontSize: "1rem",
          marginBottom: "0.5rem",
          fontWeight: "bold",
        }}
      >
        Summary Analysis
      </div>

      <div style={{ fontSize: "0.8rem" }}>
        {isLoading || error ? (
          <p>Loading...</p>
        ) : (
          <p>
            Kapasitas CPU pada Core 1 memiliki <strong>trend kenaikan</strong>{" "}
            sebesar <strong>{data.trend_percentage}% per hari</strong>, sehingga
            diprediksi pada{" "}
            <strong>{data.exceed_threshold_time.slice(0, 16)}</strong> kapasitas
            CPU akan mencapai level <strong>critical</strong> dan pada{" "}
            <strong>{data.peak_time.slice(0, 16)}</strong> akan mencapai kondisi
            penuh. Kapasitas CPU yang penuh akan mempengaruhi performa jaringan
            Anda.
          </p>
        )}
      </div>
    </div>
  );
};
